export const RatesRoute = {
  PairRates: (): string => '/coin/rates',
};
